import React from 'react';
import TextField from 'material-ui/TextField';
import Toggle from 'material-ui/Toggle';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentSave from 'material-ui/svg-icons/content/save';
import ContentClear from 'material-ui/svg-icons/content/clear';
import NumberFormat from 'react-number-format';
import {
    GridList,
    GridTile,
} from 'material-ui/GridList';

import {
    subeventoService,
    Utils,
} from '../../services';
import {
    DatePicker,
} from '../../components';
import PrincipalMaster from '../master/Principal';

class Subevento extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editing: false,
            nome: '',
            eventoSelecionado: this.props.match.params.evento,
            descricao: '',
            dataFinal: new Date(),
            dataFinalInscricoes: new Date(),
            dataFinalAvaliacoes: new Date(),
            certificadosLiberados: false,
            datasSubevento: '',
            eventoEdEviEventos: 0,

            aprovacaoNumeroLivro: 0,
            aprovacaoNumeroRegistro: 0,

            apresentacaoNumeroLivro: 0,
            apresentacaoNumeroRegistro: 0,

            avaliadorNumeroLivro: 0,
            avaliadorNumeroRegistro: 0,

            nomeLivro: '',

            textoCertificadoApresentacao: '',
            textoCertificadoAprovacao: '',
            textoCertificadoOuvinte: '',

            ouvinteDataLimiteInscricao: new Date(),
            ouvinteNumeroLivro: 0,
            ouvinteNumeroRegistro: 0,
            ouvinteEdEviEventos: 0,
            ouvinteValorInscricao: 0,
            isPosting: false,
        };
        Utils.showLoading(true);
    }

    async componentWillMount() {
        this._csrf = (await subeventoService.subeventoForm()).token;
        const codigoSubevento = this.props.match.params.subevento;
        if (codigoSubevento) {
            try {
                const subevento = await subeventoService.getSubevento(codigoSubevento);
                this.setState({
                    editing: true,
                    nome: subevento.NOME,
                    descricao: subevento.DESCRICAO,
                    eventoSelecionado: this.props.match.params.evento,

                });
            } catch (error) {
                Utils.showToast(error.message);
            }
        }
        Utils.showLoading(false);
    }

    async onSave(event) {
        event.preventDefault();
        const {
            editing,
            eventoSelecionado,
            nome,
            descricao,
            dataFinal,
            dataFinalInscricoes,
            diasVencimentoBoleto,
            numeroLivro,
            dataFinalAvaliacoes,
            certificadosLiberados,
            datasSubevento,
            minPalavrasResumo,
            maxPalavrasResumo,
            caracteresReferencias,
            caracteresPalavrasChave,
            textoCertificadoApresentacao,
            textoCertificadoAprovacao,
            textoCertificadoOuvinte,
            ouvinteDataLimiteInscricao,
            ouvinteNumeroLivro,
            isPosting,
            ouvinteValorInscricao,
        } = this.state;

        if (isPosting) {
            return;
        }

        this.setState({ isPosting: true });
        try {
            let response;
            if (editing) {
                response = await subeventoService.update({ evento: eventoSelecionado, nome, descricao, dataFinal, dataFinalInscricoes, diasVencimentoBoleto, numeroLivro, dataFinalAvaliacoes, certificadosLiberados, datasSubevento, minPalavrasResumo, maxPalavrasResumo, caracteresReferencias, caracteresPalavrasChave, textoCertificadoApresentacao, textoCertificadoAprovacao, textoCertificadoOuvinte, ouvinteDataLimiteInscricao, ouvinteNumeroLivro, _csrf: this._csrf });
            } else {
                response = await subeventoService.save({ nome, evento: eventoSelecionado, descricao, dataFinal, dataFinalInscricoes, diasVencimentoBoleto, numeroLivro, dataFinalAvaliacoes, certificadosLiberados, datasSubevento, minPalavrasResumo, maxPalavrasResumo, caracteresReferencias, caracteresPalavrasChave, textoCertificadoApresentacao, textoCertificadoAprovacao, textoCertificadoOuvinte, ouvinteDataLimiteInscricao, ouvinteNumeroLivro, _csrf: this._csrf });
            }
            Utils.showToast(response.message);
            // this.props.history.goBack();
            this.setState({ isPosting: false });
        } catch (e) {
            this.setState({ isPosting: false });
            Utils.showToast(e.message);
        }
    }

    render() {
        const {
            nome,
            descricao,
            dataFinal,
            dataFinalInscricoes,
            diasVencimentoBoleto,
            numeroLivro,
            dataVencimentoBoleto,
            certificadosLiberados,
            datasSubevento,
            minPalavrasResumo,
            maxPalavrasResumo,
            caracteresReferencias,
            caracteresPalavrasChave,
            textoCertificadoApresentacao,
            textoCertificadoAprovacao,
            textoCertificadoOuvinte,
            ouvinteDataLimiteInscricao,
            ouvinteNumeroLivro,
            ouvinteDataVencimentoBoleto,
            ouvinteDiasVencimentoBoleto,
            isPosting,
        } = this.state;

        return (
            <PrincipalMaster title="Subevento" {...this.props}>
                <div>
                    <form onSubmit={e => this.onSave(e)}>
                        <div className="padding-content">
                            <TextField
                                floatingLabelText="Nome"
                                value={nome}
                                onChange={e => this.setState({ nome: e.target.value })}
                                errorText={nome ? "" : "Campo obrigatório"}
                                fullWidth={true}
                                required={true}
                            />
                            <TextField
                                floatingLabelText="Descrição"
                                value={descricao}
                                onChange={e => this.setState({ descricao: e.target.value })}
                                errorText={descricao ? "" : "Campo obrigatório"}
                                fullWidth={true}
                                required={true}
                                multiLine={true}
                                rows={3}
                            />
                            <GridList cols={3} cellHeight="auto">
                                <GridTile cols={1}>
                                    <DatePicker
                                        value={dataFinal}
                                        onChange={date => this.setState({ dataFinal: date })}
                                        openToYearSelection={true}
                                        required={true}
                                        floatingLabelText="Data final do evento"
                                        errorText={dataFinal ? "" : "Campo obrigatório"}
                                    />
                                </GridTile>
                                <GridTile cols={1}>
                                    <DatePicker
                                        value={dataFinalInscricoes}
                                        onChange={date => this.setState({ dataFinalInscricoes: date })}
                                        openToYearSelection={true}
                                        required={true}
                                        floatingLabelText="Data final inscrições"
                                        errorText={dataFinalInscricoes ? "" : "Campo obrigatório"}
                                    />
                                </GridTile>
                                <GridTile cols={1}>
                                    <DatePicker
                                        value={dataVencimentoBoleto}
                                        onChange={date => this.setState({ dataVencimentoBoleto: date })}
                                        openToYearSelection={true}
                                        required={true}
                                        floatingLabelText="Data final avaliações"
                                        errorText={dataVencimentoBoleto ? "" : "Campo obrigatório"}
                                    />
                                </GridTile>
                            </GridList>
                            <GridList cols={2} cellHeight="auto">
                                <GridTile cols={1}>
                                </GridTile>
                                <GridTile cols={1}>
                                </GridTile>
                            </GridList>
                            <GridList cols={3} cellHeight="auto">
                                <GridTile cols={1}>
                                    <TextField
                                        type="number"
                                        required={true}
                                        value={diasVencimentoBoleto}
                                        errorText={diasVencimentoBoleto ? "" : "Campo obrigatório"}
                                        floatingLabelText="Dias vencimento boleto"
                                        onChange={e => this.setState({ diasVencimentoBoleto: e.target.value })}
                                    />
                                </GridTile>
                                <GridTile cols={1}>
                                    <TextField
                                        type="number"
                                        value={numeroLivro}
                                        errorText={numeroLivro ? "" : "Campo obrigatório"}
                                        floatingLabelText="Número do livro"
                                        onChange={e => this.setState({ numeroLivro: e.target.value })}
                                    />
                                </GridTile>
                                <GridTile cols={1}>
                                    <TextField
                                        floatingLabelText="Data do subevento"
                                        value={datasSubevento}
                                        onChange={e => this.setState({ datasSubevento: e.target.value })}
                                        errorText={datasSubevento ? "" : "Campo obrigatório"}
                                        fullWidth={true}
                                        required={true}
                                    />
                                </GridTile>
                            </GridList>
                            <GridList cols={4} cellHeight="auto">
                                <GridTile cols={1}>
                                    <TextField
                                        type="number"
                                        required={true}
                                        value={minPalavrasResumo}
                                        errorText={minPalavrasResumo ? "" : "Campo obrigatório"}
                                        floatingLabelText="Mínimo de palavras no resumo"
                                        onChange={e => this.setState({ minPalavrasResumo: e.target.value })}
                                    />
                                </GridTile>
                                <GridTile cols={1}>
                                    <TextField
                                        type="number"
                                        required={true}
                                        value={maxPalavrasResumo}
                                        errorText={maxPalavrasResumo ? "" : "Campo obrigatório"}
                                        floatingLabelText="Máximo de palavras no resumo"
                                        onChange={e => this.setState({ maxPalavrasResumo: e.target.value })}
                                    />
                                </GridTile>
                                <GridTile cols={1}>
                                    <TextField
                                        type="number"
                                        required={true}
                                        value={caracteresReferencias}
                                        errorText={caracteresReferencias ? "" : "Campo obrigatório"}
                                        floatingLabelText="Caracteres referências"
                                        onChange={e => this.setState({ caracteresReferencias: e.target.value })}
                                    />
                                </GridTile>
                                <GridTile cols={1}>
                                    <TextField
                                        type="number"
                                        required={true}
                                        value={caracteresPalavrasChave}
                                        errorText={caracteresPalavrasChave ? "" : "Campo obrigatório"}
                                        floatingLabelText="Caracteres palavras resumo"
                                        onChange={e => this.setState({ caracteresPalavrasChave: e.target.value })}
                                    />
                                </GridTile>
                            </GridList>
                            <TextField
                                floatingLabelText="Texto certificado aprovação"
                                value={textoCertificadoAprovacao}
                                onChange={e => this.setState({ textoCertificadoAprovacao: e.target.value })}
                                errorText={textoCertificadoAprovacao ? "" : "Campo obrigatório"}
                                fullWidth={true}
                                multiLine={true}
                                rows={10}
                            />
                            <TextField
                                floatingLabelText="Texto certificado apresentação"
                                value={textoCertificadoApresentacao}
                                onChange={e => this.setState({ textoCertificadoApresentacao: e.target.value })}
                                errorText={textoCertificadoApresentacao ? "" : "Campo obrigatório"}
                                fullWidth={true}
                                multiLine={true}
                                rows={10}
                            />
                            <TextField
                                floatingLabelText="Texto certificado ouvinte"
                                value={textoCertificadoOuvinte}
                                onChange={e => this.setState({ textoCertificadoOuvinte: e.target.value })}
                                errorText={textoCertificadoOuvinte ? "" : "Campo obrigatório"}
                                fullWidth={true}
                                multiLine={true}
                                rows={10}
                            />
                            <DatePicker
                                value={ouvinteDataLimiteInscricao}
                                onChange={date => this.setState({ ouvinteDataLimiteInscricao: date })}
                                openToYearSelection={true}
                                required={true}
                                floatingLabelText="Data limite inscrições ouvinte"
                                errorText={ouvinteDataLimiteInscricao ? "" : "Campo obrigatório"}
                            />
                            <br />
                            <TextField
                                type="number"
                                value={ouvinteNumeroLivro}
                                errorText={ouvinteNumeroLivro ? "" : "Campo obrigatório"}
                                floatingLabelText="Número livro ouvinte"
                                onChange={e => this.setState({ ouvinteNumeroLivro: e.target.value })}
                            />
                            <DatePicker
                                value={ouvinteDataVencimentoBoleto}
                                onChange={date => this.setState({ ouvinteDataVencimentoBoleto: date })}
                                openToYearSelection={true}
                                required={true}
                                floatingLabelText="Data vencimento boleto ouvinte"
                                errorText={ouvinteDataVencimentoBoleto ? "" : "Campo obrigatório"}
                            />
                            <TextField
                                type="number"
                                required={true}
                                value={ouvinteDiasVencimentoBoleto}
                                errorText={ouvinteDiasVencimentoBoleto ? "" : "Campo obrigatório"}
                                floatingLabelText="Dias vencimento boleto ouvinte"
                                onChange={e => this.setState({ ouvinteDiasVencimentoBoleto: e.target.value })}
                            />
                            <br />
                            <Toggle
                                toggled={certificadosLiberados}
                                labelPosition="right"
                                label="Certificados liberados?"
                                onToggle={(e, checked) => this.setState({ certificadosLiberados: checked })}
                            />
                        </div>
                        <div className="fab-buttons">
                            <FloatingActionButton type="submit" disabled={isPosting} style={{ marginRight: 8 }}>
                                <ContentSave />
                            </FloatingActionButton>
                            <FloatingActionButton onClick={() => this.props.history.goBack()} backgroundColor="rgb(100, 100, 100)">
                                <ContentClear />
                            </FloatingActionButton>
                        </div>
                    </form>
                </div>
            </PrincipalMaster>
        );
    }
}

export default Subevento;